import { Component, Input } from '@angular/core';

type BannerSeverity = "yellow" | "red";

@Component({
  selector: 'app-banner',
  standalone: false,
  templateUrl: './app-banner.component.html',
  styleUrl: './app-banner.component.scss'
})
export class AppBannerComponent {

  @Input() text: string = '';
  @Input() severity: BannerSeverity = 'red';

}
